<template>
  <f7-page :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar :title="'Reparto Contratación NEW'" :back-link="$t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="RepartoContratacion"
        tableCode="REPARTOCONTRATACIONNEW"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :shownFields="['pedidoResumen._id', 'pedidoResumen.numero', 'pedidoResumen.codigo', 'lineaResumen.estado.estado', 'lineaResumen.numero', 'lineaResumen.tipoLinea', 'lineaResumen.direccionInspeccion.cp', 'lineaResumen.direccionInspeccion.poblacion', 'lineaResumen.direccionInspeccion.provincia', 'lineaResumen.direccionInspeccion.comunidad', 'lineaResumen.idExpediente', 'lineaResumen.contratacion.codEmpleado', 'lineaResumen.cliente.empleadoVentas', 'lineaResumen.cliente.responsable', 'lineaResumen.cliente.nif', 'lineaResumen.inspectores', 'lineaResumen.camposUsuario.cpEj', 'lineaResumen.calificacion', 'lineaResumen.expedienteManual', 'lineaResumen.estadoExpediente', 'lineaResumen.emailComunicaciones', 'lineaResumen.emailContacto', 'lineaResumen.administrador', 'lineaResumen.instalador', 'lineaResumen.mantenedor', 'lineaResumen.asociacion', 'pedidoResumen.bcId']"
        :massiveActions="false"
        :controlsWidth="120"
        :searchOnInit="searchOnInit"
        :paginationFilterSort="true"
      >
        <template v-slot:optionsColumn="{item}">
          <f7-link v-tooltip="$t('common.ver') + ' Pedido'" icon-f7="eye" color="green" :href="`/pedidos/view/${item.pedidoResumen.id}/`"></f7-link>
          <f7-link
            external
            v-tooltip="'Ver Expediente'"
            v-if="item.lineaResumen.idExpediente"
            :icon-f7="item.lineaResumen.expedienteManual ? 'doc_plaintext' : 'checkmark_seal'"
            :color="getColorExpediente(item)"
            :href="`#!/inspecciones/view/${item.lineaResumen.idExpediente}/`"
          ></f7-link>
          <f7-link
            v-tooltip="'Crear Exp.Manual'"
            v-if="!item.lineaResumen.idExpediente || (item.lineaResumen.estadoExpediente && item.lineaResumen.estadoExpediente == 'PLANIFICADO')"
            :icon-f7="'hand_raised'"
            @click="crearExpManualConLinea(item.pedidoResumen.id, item.numero)"
          ></f7-link>
          <!-- Abrir popup facturas -->
          <f7-link icon-f7="doc_plaintext" color="red" @click="mostrarFacturas(item)" v-tooltip="'Ver Facturas'"></f7-link>
          <f7-link v-if="item.pedidoResumen.bcId" v-roles="['ADMIN', 'ADMINISTRACION']" v-tooltip="$t('pedidos.verEnBC')" icon-f7="link" color="orange" @click="verEnBC(item.pedidoResumen.bcId)"></f7-link>
          <f7-link v-roles="['ADMIN', 'ADMINISTRACION']" v-tooltip="$t('pedidos.enviarBC')" icon-f7="arrow_up_circle" color="purple" @click="enviarBC(item.pedidoResumen.id)"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
    <f7-popup tablet-fullscreen ref="popupListadoFacturas" class="popup-listado-facturas" :opened="popupListadoFacturasOpened" v-if="popupListadoFacturasOpened && numeroPedidoParaFactura" @popup:closed="popupListadoFacturasOpened = false; numeroPedidoParaFactura = null; " swipe-to-close>
      <Facturas :search-on-init="true" :is-popup="true" :shown-fields="['numeroPedido']" :mandatory-filter="{ 'numeroPedido': numeroPedidoParaFactura }" :ignore-table-filters="true"/>
    </f7-popup>
  </f7-page>
</template>
<style scoped>
  .label-group {
    margin-top: 20px;
    margin-left: 20px;
    font-weight: bold;
  }
</style>
<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import RepartoContratacion from "./../../js/db/RepartoContratacion.js";
import Facturas from "../facturas/facturas.vue";
import Pedido from "./../../js/db/Pedido.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";

export default {
  components: {
    rDynamicList,
    Facturas,
  },
  data() {
    return {
      RepartoContratacion,
      Pedido,
      popupListadoFacturasOpened: false,
      numeroPedidoParaFactura: null,
    };
  },
  props: {
    searchOnInit: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {
    getColorExpediente: function (linea) {
      if (!linea || !linea.lineaResumen || !linea.lineaResumen.calificacion) {
        return "gray";
      }
      if(linea.lineaResumen.calificacion == 'FAVORABLE' || linea.lineaResumen.calificacion =='FAVORABLE_CON_DEFECTOS' || linea.lineaResumen.calificacion =='FAVORABLE_CON_REPARO' ) {
        return "green";
      }
      if(linea.lineaResumen.calificacion == 'DESFAVORABLE') {
        return "orange";
      }
      if(linea.lineaResumen.calificacion == 'NEGATIVO') {
        return "red";
      }

    },
    crearExpManualConLinea: function(idPedido, numLinea) {
      var self = this;
      var app = self.$f7;
      var jsonData = {idPedido: idPedido, numLinea: numLinea};
      jsonData = Object.values(jsonData);
        app.views.current.router.navigate(
          "/inspecciones/new/?jsonData=" + JSON.stringify(jsonData)
        );
    },
    mostrarFacturas(linea) {
      const self = this;
      self.numeroPedidoParaFactura = linea.pedidoResumen.numero;
      self.popupListadoFacturasOpened = true;
    },
    verEnBC: function (bcId) {
      var self = this;
      var app = self.$f7;
      if (!bcId) {
        app.dialog.alert(self.$t('pedidos.bcId_no_disponible') || 'No hay bcId para este pedido.');
        return;
      }
      const baseUrl = process.env.VUE_APP_BC_WEB_URL || process.env.VUE_APP_BC_URL || '';
      if (!baseUrl) {
        app.dialog.alert('Configura VUE_APP_BC_WEB_URL para abrir el pedido en Business Central');
        return;
      }
      const environment = process.env.VUE_APP_BC_ENVIRONMENT ? `${process.env.VUE_APP_BC_ENVIRONMENT}/` : '';
      const company = process.env.VUE_APP_BC_COMPANY_ID;
      const companyParam = company ? `company=${encodeURIComponent(company)}` : '';
      const pageParam = 'page=42';
      const filterParam = `filter='$systemId' IS '${encodeURIComponent(bcId)}'`;
      const query = [companyParam, pageParam, filterParam].filter(Boolean).join('&');
      const url = `${baseUrl.replace(/\/$/, '')}/${environment}?${query}`;
      window.open(url, '_blank');
    },
    enviarBC: function (idPedido) {
      var self = this;
      var app = self.$f7;
      // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Pedido.enviarBC({ itemId: idPedido }).then(function (res) {
        espera.cerrar();
        app.toast
          .create({
            text: self.$t("pedidos.envio_bc_ok"),
            position: "center",
            closeTimeout: 2000,
            icon: '<i class="f7-icons">checkmark_alt</i>'
          })
          .open();
        self.$refs.rlist.reload();
      }).catch(function (error) {
        espera.cerrar();
        app.dialog.alert(error.message);
      });
    },
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
    // miramos si  en la url viene el parámetro selectedReparto
    let parametros = self.$f7route.url.split('?')[1];
    let filter;
    if (parametros) {
      try {
        eval(parametros.replaceAll('&',';'));
        
      } catch(_){}
    }
  }
};
</script>